import { render, staticRenderFns } from "./RoadLocations.vue?vue&type=template&id=40e547e6"
import script from "./RoadLocations.vue?vue&type=script&lang=js"
export * from "./RoadLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports